import React, { useEffect, useState } from "react";
import "assets/scss/material-dashboard-pro-react/loader.css";
import cargoLoader from "assets/img/cargoLoader.png";

/**
 * Loader component
 *
 * @returns {JSX.Element} JSX of loader
 */
export default function Loader() {
	const [loop, setLoop] = useState(1);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoop(2);
		}, 5000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="loader-container">
			<img
				src={cargoLoader}
				alt="Loading..."
				className={`loader-gif`}
				style={{ opacity: loop === 1 ? "1" : "0", position: "absolute" }}
			/>
			<img
				src={cargoLoader}
				alt="Loading..."
				className={`loader-gif`}
				style={{ opacity: loop !== 1 ? "1" : "0", position: "absolute" }}
			/>
		</div>
	);
}
